import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import { perfMark, perfMeasure } from '@core/perf/perf-marks';

if (environment.production) {
  enableProdMode();
}

// AT-9296: dwie fazy startu, ktorych nie widac w Resource Timing ani w Web Vitals —
// oczekiwanie na DOMContentLoaded i sam bootstrap Angulara. Razem odpowiadaja za czas
// miedzy dostarczeniem bundla a pierwszym zadaniem API, czyli za poczatek kaskady.
perfMark('skrypt-wczytany');

document.addEventListener('DOMContentLoaded', () => {
  perfMeasure('oczekiwanie-na-dom', 'skrypt-wczytany');
  perfMark('bootstrap-start');

  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(() => perfMeasure('bootstrap-angulara', 'bootstrap-start'))
    .catch(err => console.error(err));
});

